/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { FeatureRoutePermission } from "@farmlands/permissions";

import { getRelativeRouteWithQueryParams } from "../../../util/routing";
import { CART_ROUTE_NAME } from "../../cart/constants";

const BASE = "/products";

export const PRODUCTS_ROUTES = {
  BASE,
  ROOT: `${BASE}/*`,
  NAME: "Shop",
} as const;

export const PRODUCTS_ROUTE_PERMISSION: FeatureRoutePermission = {
  mode: "single",
  permission: "FarmlandsProShop_ShopView",
};

export const PRODUCTS_TAB_0_ROUTE = getRelativeRouteWithQueryParams(PRODUCTS_ROUTES.BASE, {
  tab: 0,
});

export const PRODUCTS_CART_ROUTE = `${PRODUCTS_ROUTES.BASE}/${CART_ROUTE_NAME}`;

export const PRODUCTS_TRADER_DEALS_SEGMENT = "trader-deals";

export const PRODUCTS_NOT_FOUND_SEGMENT = "not-found";
export const PRODUCT_DETAILS_SEGMENT = ":masterProductId";
export const PRODUCTS_CART_SEGMENT = CART_ROUTE_NAME;
export const PRODUCTS_CHECKOUT_SEGMENT = "checkout/:confirmationId";
export const PRODUCTS_ENQUIRY_REQUEST_SENT = "enquiry-request-sent";

export const PRODUCTS_TRADER_DEALS_ROUTE = `${PRODUCTS_ROUTES.BASE}/${PRODUCTS_TRADER_DEALS_SEGMENT}`;
